import { action } from 'mobx';
import moment from 'moment';
import { BasePreviewViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import _ from "lodash";

@applicationContext
class UserPreviewViewStore extends BasePreviewViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
            name: 'user',
            autoInit: true,
            id: id,
            authorization: 'coreUserSection.update',
            routes: {
                edit: () => {
                    this.rootStore.routerStore.goTo(
                        'master.app.main.user.edit',
                        { id: this.id }
                    );
                }
            },
            actions: () => {
                const service = rootStore.application.baasic.membershipModule.user;
                return {
                    get: async (id) => {
                        const response = await service.get(id, { embed: 'roles' });
                        return response.data;
                    }
                }
            }
        });
    }

    @action
    setData() {
        const creationDate = this.item.creationDate;
        const lastLoginDate = this.item.lastLoginDate;
        this.item.creationDate = moment(creationDate).format("MM/DD/YYYY");
        this.item.creationTime = moment(creationDate).format("LT");
        this.item.lastLoginDate = moment(lastLoginDate).format("MM/DD/YYYY");

        if (this.item.lastLoginDate === '01/01/1754') {
            this.item.lastLoginDate = null;
        }
        this.item.lastLoginTime = moment(lastLoginDate).format("LT");
        this.item.roleNames = _.join(_.map(this.item.roles, 'name'), ', ');   
    }
    
    @action.bound
    async getResource(id) {
        await super.getResource(id);
        this.setData();
    }
}

export default UserPreviewViewStore;
